<template>
  <div class="container-fluid">

    <div class="row py-3">
      <div class="col-md-12">
        <h1 class="text-center">Groups</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-md-7 mx-auto">
        <button type="button" class="btn btn-success mb-3" @click="createGroup">Create group</button>

        <groups-table :groups="groups" v-if="groups"></groups-table>

        <loading :loading="loading"></loading>

      </div>
    </div>

  </div>
</template>


<script>
import GroupsTable from '../components/tables/GroupsTable'

export default {
  components: {
    GroupsTable,
  },
  created() {
    this.loading = true
    this.$store.dispatch('loadGroups')
      .finally(() => {
        this.loading = false
      })
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    groups() {
      return this.$store.getters.getGroups
    },
  },
  methods: {
    createGroup() {
      let name = window.prompt('Client Group Name:')
      if (name) {
        this.loading = true
        this.$store.dispatch('addGroup', name)
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/GroupsPage.vue